import React from 'react';
import CoreComponent from "../../../../Core/CoreComponent";
import Theme from '../../../../Themes/ThemeArtLexie'
import settings from '../../Settings/Settings';
import AppbarComponent from '../Appbar/Appbar';
import ErrorSnackbar from '../../../../CommonComponents/ErrorSnackbar/ErrorSnackbar';
import LoadingComponent from '../LoadingComponent/LoadingComponent'
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default class UserOrderComponent extends CoreComponent {

    constructor(props) {
        super(props);
        this.loadComponentsProps()
        this.useTheme(Theme)
        this.basicComponentConstants = {
            language: props.getManagerState().language,
            history: props.history,
            user: props.getManagerState().user,
        }
    }

    componentDidMount() {
        this.getOrderAction()
        this.getOrderItemsAction()
        super.componentDidMount()
    }
    loadComponentsProps() {
        const that = this
        this.setComponentsConstants('AppbarComponent', {
            ...this.basicComponentConstants
        }).setComponentsMethods('AppbarComponent', {
            setManagerState: (object, callback) => {
                that.props.setManagerState(object, callback)
            },
            refreshMainComponent: () => {
                that.refresh()
            },
            getManagerState: () => {
                return that.props.getManagerState()
            },
            changeRoute: (route) => {
                that.props.changeRoute(route)
            },
            getLocalStorage: (storageName) => {
                return that.getLocalStorage(storageName)
            }
        })
    }

    getOrderAction() {
        let that = this
        let endpoint = settings.API_ENDPOINT_ORDER + this.props.urlParams.ordersID + '/' + this.props.urlParams.ordersSha
        let accountToken = ''
        if(this.getLocalStorage('user') && this.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + this.getLocalStorage('user').tokensHash
        }
        endpoint += accountToken
        this.props.setManagerState(
            {userOrder: [], loadedUserOrder: false, emptyUserOrder: false, ordersDeliveryMethodsPrice: 0}, 
            () => {
                this.ajax(settings.API_URL + endpoint,{},"GET", null, 
                    (data) => {
                        if(data.items.length) {
                            this.props.setManagerState(
                                {userOrder: data.items, loadedUserOrder: true, ordersDeliveryMethodsPrice: data.items[0].ordersDeliveryMethodsPrice},
                                () => {
                                    that.getInvoiceAddressAction()
                                    that.getDeliveryAddressAction()
                                    that.getOrderInformationAction()
                                })
                        } else {
                            that.props.setManagerState({emptyUserOrder: true})
                        }
                    },
                    {},
                    false,
                    () => {
                        that.props.setManagerState({emptyUserOrder: true})
                    },
                    () => {
                        that.props.setManagerState({emptyUserOrder: true})
                    })
            })
      }
      getInvoiceAddressAction() {
        let endpoint = settings.API_ENDPOINT_USER_ORDER_INVOICE_ADDRESS + this.props.getManagerState().userOrder[0].ordersID + '/' + this.props.getManagerState().userOrder[0].ordersSha
        let accountToken = ''
        if(this.getLocalStorage('user') && this.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + this.getLocalStorage('user').tokensHash
        }
        endpoint += accountToken
        this.props.setManagerState({userOrderInvoiceAddress: [], loadedUserOrderInvoiceAddress: false}, () => {
                this.ajax(settings.API_URL + endpoint,{},"GET", null, 
                    (data) => {
                        if(data.items.length) {
                            this.props.setManagerState({userOrderInvoiceAddress: data.items, loadedUserOrderInvoiceAddress: true})
                        }
                })
        })

      }
      getDeliveryAddressAction() {
        let endpoint = settings.API_ENDPOINT_USER_ORDER_DELIVERY_ADDRESS + this.props.getManagerState().userOrder[0].ordersID + '/' + this.props.getManagerState().userOrder[0].ordersSha
        let accountToken = ''
        if(this.getLocalStorage('user') && this.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + this.getLocalStorage('user').tokensHash
        }
        endpoint += accountToken
        this.props.setManagerState({userOrderDeliveryAddress: [], loadedUserOrderDeliveryAddress: false}, () => {
            this.ajax(settings.API_URL + endpoint,{},"GET", null, 
                (data) => {
                    if(data.items.length) {
                        this.props.setManagerState({userOrderDeliveryAddress: data.items, loadedUserOrderDeliveryAddress: true})
                    }
            })
        })
      }
      getOrderInformationAction() {
        let endpoint = settings.API_ENDPOINT_ORDER_INFORMATION + this.props.getManagerState().userOrder[0].ordersID + '/' + this.props.getManagerState().userOrder[0].ordersSha
        let accountToken = ''
        if(this.getLocalStorage('user') && this.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + this.getLocalStorage('user').tokensHash
        }
        endpoint += accountToken
        this.props.setManagerState({orderInformation: null, loadedOrderInformation: false}, () => {
            this.ajax(settings.API_URL + endpoint,{},"GET", null, 
                (data) => {
                    if(data.items.length) {
                        this.props.setManagerState({orderInformation: data.items[0], loadedOrderInformation: true})
                    }
            })
        })
      }
      getOrderItemsAction() {
        let accountToken = ''
        if(this.getLocalStorage('user') && this.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + this.getLocalStorage('user').tokensHash
        }
        this.props.setManagerState({userOrderItems: [], loadedUserOrderItems: false, userOrderTotal: 0}, () => {
            this.ajax(settings.API_URL + settings.API_ENDPOINT_ORDER_ITEMS + this.props.urlParams.ordersID + '/'+ this.props.urlParams.ordersSha + accountToken,{},'GET',null, (data) => {
                let userOrderTotal = 0
                for(let i in data.items) {
                    userOrderTotal += data.items[i].ordersItemsQuantity * data.items[i].ordersItemsUnitPrice
                }
                this.props.setManagerState({userOrderItems: data.items, loadedUserOrderItems: true, userOrderTotal: userOrderTotal})
            })
        })
      }
    getRender() {

        let classes = {
            root: {
              display: 'block',
              maxWidth: '750px',
              margin: '70px auto',
              padding: '8px',
              '& > *': {
                margin: 1,
                width: 16,
                height: 16,
              },
            },
            img: {
                maxWidth: '150px',
                maxHeight: '150px'
            },
            proceedToCheckout: {
                textDecoration: 'none',
                display: "block",
                margin: "0 5px",
                width: "100%",
                color: 'inherit'
              },
              rootPaper: {
                maxWidth: 750,
                padding: 8,
                margin: '0 auto'
            },
          };
        this.loadComponentsProps()
        return <Paper style={classes.rootPaper}><div style={classes.root} id="rootComponent">
                    <AppbarComponent {...this.buildComponentProps('AppbarComponent')} />
                    {this.props.getManagerState().loadedUserOrder && !this.props.getManagerState().emptyUserOrder ?
                        <Typography variant="h3" component="h3" style={classes.title}>
                            {this.props.getManagerState().language.LANG_ORDER} 
                            &nbsp;#{this.props.getManagerState().userOrder[0] ? this.props.getManagerState().userOrder[0].ordersID: null} - 
                            &nbsp;{this.props.getManagerState().language[this.props.getManagerState().userOrder[0].ordersStatusesName]}
                        </Typography>
                        :
                        <LoadingComponent />
                    }
                    {this.props.getManagerState().loadedUserOrder && !this.props.getManagerState().emptyUserOrder ?
                        <React.Fragment>
                            <Paper>
                                <Typography variant="h5" component="h5" style={classes.title}>
                                    {this.props.getManagerState().language.LANG_DELIVERY_METHOD} 
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    {this.props.getManagerState().language[this.props.getManagerState().userOrder[0].deliveryMethodsName]} +{(this.props.getManagerState().userOrder[0].ordersDeliveryMethodsPrice/100).toFixed(2)}{this.props.getManagerState().language.LANG_CURRENCY}
                                </Typography>
                            </Paper>
                            <Paper>
                            <Typography variant="h5" component="h5" style={classes.title}>
                                {this.props.getManagerState().language.LANG_ORDERS_PAYMENT_METHOD} 
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                {this.props.getManagerState().userOrder[0].ordersPaymentMethod}
                            </Typography>
                            </Paper>                            
                        </React.Fragment>
                        :
                        null
                    }
                    {this.props.getManagerState().loadedUserOrderDeliveryAddress ?
                            <Paper>
                                <Typography variant="h5" component="h5" style={classes.title}>
                                    {this.props.getManagerState().language.LANG_DELIVERY_ADDRESS} 
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    {this.props.getManagerState().userOrderDeliveryAddress[0].addressFirstName} {this.props.getManagerState().userOrderDeliveryAddress[0].addressLastName} {this.props.getManagerState().userOrderDeliveryAddress[0].addressStreet} {this.props.getManagerState().userOrderDeliveryAddress[0].addressNumber} {this.props.getManagerState().userOrderDeliveryAddress[0].addressBlock} {this.props.getManagerState().userOrderDeliveryAddress[0].addressEntrance} {this.props.getManagerState().userOrderDeliveryAddress[0].addressFloor} {this.props.getManagerState().userOrderDeliveryAddress[0].addressApartment} {this.props.getManagerState().userOrderDeliveryAddress[0].addressCity} {this.props.getManagerState().userOrderDeliveryAddress[0].countiesName}, {this.props.getManagerState().userOrderDeliveryAddress[0].addressCountry} {this.props.getManagerState().userOrderDeliveryAddress[0].addressPhoneNumber} {this.props.getManagerState().userOrderDeliveryAddress[0].addressObservations}
                                </Typography>
                            </Paper>    
                        :
                        null
                    }
                    {this.props.getManagerState().loadedUserOrderInvoiceAddress && !this.props.getManagerState().emptyUserOrder ?
                            <Paper>
                            <Typography variant="h5" component="h5" style={classes.title}>
                                {this.props.getManagerState().language.LANG_BILLING_ADDRESS} 
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                {this.props.getManagerState().userOrderInvoiceAddress[0].addressFirstName} {this.props.getManagerState().userOrderInvoiceAddress[0].addressLastName} {this.props.getManagerState().userOrderInvoiceAddress[0].addressStreet} {this.props.getManagerState().userOrderInvoiceAddress[0].addressNumber} {this.props.getManagerState().userOrderInvoiceAddress[0].addressBlock} {this.props.getManagerState().userOrderInvoiceAddress[0].addressEntrance} {this.props.getManagerState().userOrderInvoiceAddress[0].addressFloor} {this.props.getManagerState().userOrderInvoiceAddress[0].addressApartment} {this.props.getManagerState().userOrderInvoiceAddress[0].addressCity} {this.props.getManagerState().userOrderInvoiceAddress[0].countiesName}, {this.props.getManagerState().userOrderInvoiceAddress[0].addressCountry} {this.props.getManagerState().userOrderInvoiceAddress[0].addressPhoneNumber} {this.props.getManagerState().userOrderInvoiceAddress[0].addressObservations}
                            </Typography>
                            </Paper>   
                        :
                        null
                    }
                    {this.props.getManagerState().loadedOrderInformation &&  this.props.getManagerState().orderInformation?
                            <Paper>
                                <Typography variant="h5" component="h5" style={classes.title}>
                                    {this.props.getManagerState().language.LANG_JURIDICAL_PERSON} 
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    {this.props.getManagerState().language.LANG_FIRM_NAME}: <b>{this.props.getManagerState().orderInformation.shopFirmsName}</b> <br />
                                    {this.props.getManagerState().language.LANG_CREATE_ACCOUNT_CIF}: <b>{this.props.getManagerState().orderInformation.shopFirmsCif}</b> <br />
                                    {this.props.getManagerState().language.LANG_CREATE_ACCOUNT_NO_ORC}: <b>{this.props.getManagerState().orderInformation.shopFirmsOrcNumber}</b> <br />
                                    {this.props.getManagerState().language.LANG_CREATE_ACCOUNT_FIRM_ADDRESS}: <b>{this.props.getManagerState().orderInformation.shopFirmsAddress}</b> <br />
                                    {this.props.getManagerState().language.LANG_CREATE_ACCOUNT_FIRM_BANK}: <b>{this.props.getManagerState().orderInformation.shopFirmsBank}</b>
                                </Typography>
                            </Paper>    
                        :
                        null
                    }
                    {
                        this.props.getManagerState().loadingUserOrders ?
                        <LoadingComponent />
                        :
                        null
                    }
                    {!this.props.getManagerState().emptyUserOrder ?
                    <Typography variant="h5" component="h5" style={classes.title}>
                        {this.props.getManagerState().language.LANG_ORDERS_ITEMS} 
                    </Typography>
                    :
                    null
                    }
                    {
                        this.props.getManagerState().loadedUserOrderItems ?
                        null
                        :
                        <Grid item xl={12} md={12} sm={12}>
                            <LoadingComponent />
                        </Grid>
                    }
                    {this.props.getManagerState().emptyUserOrder ?
                        null :

                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{this.props.getManagerState().language.LANG_DETAILS}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                    

                      {
                      this.props.getManagerState().userOrderItems.map((el, idx) => {

                            return  <TableRow key={idx}>  
                                        <TableCell>
                                            {this.props.getManagerState().language.LANG_ORDER_ITEMS_VARIANT_ID}: <b>{el.shopProductsID}</b> <br/>
                                            {this.props.getManagerState().language.LANG_ARTICLE_ID}: <b>{el.shopProductsArticleId}</b> <br/>                                        
                                            {this.props.getManagerState().language.LANG_QUANTITY}: <b>{el.ordersItemsQuantity}</b> <br/>
                                            {this.props.getManagerState().language.LANG_ARTICLE_NAME}: <b>{el.shopProductsArticleName}</b> <br />
                                            {this.props.getManagerState().language.LANG_PRODUCT_CATEGORY}: <b>{el.shopProductsCategory}</b> <br />
                                            {el.shopProductsEquipmentList ?
                                                <React.Fragment>
                                                    {this.props.getManagerState().language.LANG_PRODUCT_EQUIPMENT_LIST}: <b>{el.shopProductsEquipmentList}</b> <br />
                                                </React.Fragment>
                                            :
                                            null}
                                            {this.props.getManagerState().language.LANG_SUBTOTAL}: <b>{((el.ordersItemsQuantity * el.ordersItemsUnitPrice)/100).toFixed(2)} {this.props.getManagerState().language.LANG_CURRENCY}</b>
                                        </TableCell>
                                    </TableRow>
                        })
                        }
                        <TableRow>  
                        {!this.props.getManagerState().emptyUserOrder ?
                            <React.Fragment>
                                <TableCell>
                                    {this.props.getManagerState().language.LANG_TOTAL}
                                </TableCell>
                            </React.Fragment>
                            :
                            null
                        }
                        {!this.props.getManagerState().emptyUserOrder ?
                        <React.Fragment>
                            <TableCell>
                                <b>{(this.props.getManagerState().userOrderTotal/100).toFixed(2)} {this.props.getManagerState().language.LANG_CURRENCY}</b>
                            </TableCell>
                        </React.Fragment>
                         :
                            null
                        }
                        </TableRow>
                        {!this.props.getManagerState().emptyUserOrder ?
                            <TableRow>  
                                <TableCell>
                                    {this.props.getManagerState().language.LANG_TOTAL_ORDER}
                                </TableCell>                        
                                <TableCell>
                                    <b>{((parseInt(this.props.getManagerState().userOrderTotal) + parseInt(this.props.getManagerState().ordersDeliveryMethodsPrice))/100).toFixed(2)} {this.props.getManagerState().language.LANG_CURRENCY}</b>
                                </TableCell>
                            </TableRow>  
                            :
                            null
                        }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    }
                        <Grid item xl={12} md={12} sm={12}>
                            <Divider />
                        </Grid>
                    {this.props.getManagerState().emptyUserOrder ?
                         <Typography variant="subtitle1" gutterBottom>
                                {this.props.getManagerState().language.LANG_EMPTY_USER_ORDER}
                            </Typography>      
                        :
                        null}
                    {this.props.getManagerState().errors.map((element, index) => { 
                        return <ErrorSnackbar message={element} index={index} key={index} clearErrorMessage={this.props.clearErrorMessage}/>
                     })}
                </div>
                </Paper>
    }
}
